// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-name[data-v-284b95d5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-items: center;\n}\n.product-name .img-box[data-v-284b95d5] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-right: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
